import { render, staticRenderFns } from "./Gouyao.vue?vue&type=template&id=c1301bb0&scoped=true"
import script from "./Gouyao.vue?vue&type=script&lang=js"
export * from "./Gouyao.vue?vue&type=script&lang=js"
import style0 from "./Gouyao.vue?vue&type=style&index=0&id=c1301bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1301bb0",
  null
  
)

export default component.exports